module.exports = __webpack_public_path__ + "assets/img/phone.0db3fcd6.jpg";